import { useEffect, useState } from "react";
import { galleryItems } from "@/mocks/home";

export default function CoverWall() {
  const [preview, setPreview] = useState<number | null>(null);

  useEffect(() => {
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") setPreview(null);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  const current = preview === null ? null : galleryItems[preview];

  return (
    <section id="covers" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24">
        <div className="max-w-2xl">
          <span className="text-[11px] tracking-[0.32em] text-secondary-500">封面墙</span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            先看封面，再决定进哪一现场
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            封面取自现场实拍的第一帧，点开可以先预览大图与片段数量，再决定是否进入对应合集查看完整记录。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5">
          {galleryItems.map((item, index) => (
            <button
              key={item.id}
              type="button"
              onClick={() => setPreview(index)}
              className="group relative cursor-pointer overflow-hidden rounded-lg text-left"
            >
              <div className="h-[220px] w-full sm:h-[300px] md:h-[380px]">
                <img
                  src={item.cover}
                  alt={`${item.title}现场实拍封面`}
                  title={`私拍吃瓜 ${item.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4">
                <span className="font-label text-[10px] tracking-[0.2em] text-accent-300">
                  {item.meta}
                </span>
                <h3 className="mt-1.5 font-heading text-sm font-semibold text-background-50 md:text-base">
                  {item.title}
                </h3>
              </div>
              <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-md bg-background-50/20 text-background-50 opacity-0 backdrop-blur-sm transition-opacity duration-300 group-hover:opacity-100">
                <i className="ri-expand-diagonal-line text-base" />
              </span>
            </button>
          ))}
        </div>
      </div>

      {current && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-foreground-950/90 p-4"
          onClick={() => setPreview(null)}
          role="presentation"
        >
          <div
            className="relative w-full max-w-3xl overflow-hidden rounded-lg bg-background-50"
            onClick={(event) => event.stopPropagation()}
            role="presentation"
          >
            <button
              type="button"
              aria-label="关闭预览"
              onClick={() => setPreview(null)}
              className="absolute right-3 top-3 z-10 flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-foreground-950/60 text-background-50 transition-colors hover:bg-foreground-950/80"
            >
              <i className="ri-close-line text-lg" />
            </button>
            <div className="max-h-[70vh] w-full">
              <img
                src={current.cover}
                alt={`${current.title}现场实拍大图`}
                title={`私拍吃瓜 ${current.title}`}
                className="max-h-[70vh] w-full object-cover object-top"
              />
            </div>
            <div className="flex flex-col gap-3 p-5 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] text-accent-900">
                  {current.tag}
                </span>
                <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">
                  {current.title}
                </h3>
              </div>
              <div className="flex items-center gap-4 text-xs text-foreground-600">
                <span className="flex items-center gap-1.5">
                  <i className="ri-image-2-line text-sm text-primary-600" />
                  {current.meta}
                </span>
                <a
                  href="#collections"
                  onClick={() => setPreview(null)}
                  className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  进入同主题合集
                  <i className="ri-arrow-right-line text-sm" />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}